var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('main',[_c('div',{staticClass:"container"},[_c('condiciones')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"title h3 pl-5 text-light"},[_vm._v("Condiciones Generales")])])
}]

export { render, staticRenderFns }